export default __webpack_public_path__ + "static/media/1802.65de2e59.png";